import { Attachment } from '../../shared-components/models/attachment.model';

export class EmailAttachment extends Attachment {

    // Server Properties
    IsFileUpload: boolean;
    Base64String: string; // Please don't ask why we use 5 different variables for the same exact data...

    // Local Properties
    size: number;
}
